import { initiate9SpokesRedirect } from './ninespokes-redirect';

export default {
  initiate9SpokesRedirect,
};
